import { selectCurrentUser } from "@/Redux/features/auth/authSlice";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children, permittedRoutes = ["/login", "/sign-up", "/forget-password","/reset-password"] }) => {
  const router = useRouter();
  const user = useSelector(selectCurrentUser);


  
  useEffect(() => {
    if (!user && !permittedRoutes.includes(router.pathname)) {
      router.push("/login");
    }
  }, [user, router, permittedRoutes]);

  return children;
};

export default ProtectedRoute;
